export default {
    bind(el) {
        el.addEventListener('contextmenu', (e) => {
            e.preventDefault() // 取消默认右键菜单行为
        })
    },
 
}